/**
 *  ProductSelector script file
**/

import channelService from '@/api/channelService'
import i18n from '@/i18n'
import { CHANNEL_PRODUCT_TYPES } from '@/utils/campaignOptions'
import debounce from '@/utils/debounce'
import moment from 'moment'

const DEBOUNCE_TIME = 500

export default {
  name: 'ProductSelector',
  mixins: [],
  components: {},
  props: {
    selected: {
      type: Array,
      required: true
    },
    campaign: {
      type: Object,
      required: true
    },
    channel: {
      type: Object,
      required: true
    },
    multiple: {
      type: Boolean,
      default: false
    },
    shops: {
      type: Array,
      required: true
    },
    max: {
      type: Number,
      required: false
    },
    min: {
      type: Number,
      default: 1
    }
  },
  data () {
    return {
      options: []
    }
  },
  computed: {
    productTypeLabel () {
      return this.isService
        ? CHANNEL_PRODUCT_TYPES.DIRECT.label
        : CHANNEL_PRODUCT_TYPES.REDIRECT.label
    },
    productSelectLabel () {
      const numProducts = this.selected.length
      if (this.multiple) {
        if (numProducts > 0) {
          return this.isService
            ? i18n.tc('N_SERVICES_SELECTED', numProducts)
            : i18n.tc('N_PRODUCTS_SELECTED', numProducts)
        } else {
          return this.isService
            ? i18n.t('SELECT_SERVICES')
            : i18n.t('SELECT_PRODUCTS')
        }
      } else {
        if (numProducts > 0) {
          return this.selected[0].name
        } else {
          return `${i18n.t('SELECT_A')} ${this.productTypeLabel}`
        }
      }
    },
    isProduct () {
      return this.channel.direction === CHANNEL_PRODUCT_TYPES.REDIRECT.value
    },
    isService () {
      return this.channel.direction === CHANNEL_PRODUCT_TYPES.DIRECT.value
    }
  },
  watch: {
    isService () {
      this.options = []
      this.productSearch()
    }
  },
  mounted () {
    this._productSearch = debounce(this.productSearch, DEBOUNCE_TIME + 250)
    this.productSearch()
  },
  methods: {
    slowProductSearch (query) { this._productSearch(query) },
    productSearch (query = '') {
      channelService.getSummary('products', query, {
        is_service: this.isService,
        shop_related__in: this.shops,
        date: moment(this.campaign.created_at).format('YYYY-MM-DD')
      }, true).then(data => {
        this.options = data.sort((a, b) => a.shop_related.id - b.shop_related.id).filter(p => p.is_service === this.isService)
      }).catch(err => {
        // eslint-disable-next-line
        console.error('[product-selector.js] Error searching products', err)
      })
    },
    onProductSelected (product) {
      let newProducts
      if (this.multiple) {
        if (this.productIsSelected(product)) {
          newProducts = this.selected.filter(p => p.id !== product.id)
        } else {
          newProducts = this.selected.concat(product)
          if (this.selected.length >= this.max) {
            this.$refs.productSelector.close()
          }
        }
      } else {
        newProducts = [product]
        this.$refs.productSelector.close()
      }

      this.$emit('selected', newProducts)
    },
    productIsSelected (product) {
      return this.selected.some(p => p.id === product.id)
    },
    getProductSubtext (product) {
      return `${i18n.t('REFERENCE_SHORT')} ${product.reference} - ${product.shop_related.name}`
    }
  }
}
